var _rect, _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _path14, _path15, _g, _rect2, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgPlayStore(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 135,
    height: 40,
    viewBox: "0 0 135 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 0.5,
    y: 0.500092,
    width: 134,
    height: 39,
    rx: 4.5,
    fill: "black"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M68.136 21.7512C65.784 21.7512 63.867 23.5402 63.867 26.0042C63.867 28.4532 65.784 30.2572 68.136 30.2572C70.489 30.2572 72.406 28.4532 72.406 26.0042C72.405 23.5402 70.488 21.7512 68.136 21.7512ZM68.136 28.5832C66.847 28.5832 65.736 27.5202 65.736 26.0052C65.736 24.4742 66.848 23.4272 68.136 23.4272C69.425 23.4272 70.536 24.4742 70.536 26.0052C70.536 27.5192 69.425 28.5832 68.136 28.5832ZM58.822 21.7512C56.47 21.7512 54.553 23.5402 54.553 26.0042C54.553 28.4532 56.47 30.2572 58.822 30.2572C61.175 30.2572 63.092 28.4532 63.092 26.0042C63.092 23.5402 61.175 21.7512 58.822 21.7512ZM58.822 28.5832C57.533 28.5832 56.422 27.5202 56.422 26.0052C56.422 24.4742 57.534 23.4272 58.822 23.4272C60.111 23.4272 61.222 24.4742 61.222 26.0052C61.223 27.5192 60.111 28.5832 58.822 28.5832ZM47.744 23.0572V24.8612H52.062C51.933 25.8762 51.595 26.6172 51.079 27.1322C50.451 27.7602 49.468 28.4532 47.744 28.4532C45.086 28.4532 43.008 26.3102 43.008 23.6522C43.008 20.9942 45.086 18.8512 47.744 18.8512C49.178 18.8512 50.225 19.4152 50.998 20.1402L52.271 18.8672C51.191 17.8362 49.758 17.0472 47.744 17.0472C44.103 17.0472 41.042 20.0112 41.042 23.6522C41.042 27.2932 44.103 30.2572 47.744 30.2572C49.709 30.2572 51.192 29.6122 52.351 28.4042C53.543 27.2122 53.914 25.5362 53.914 24.1832C53.914 23.7652 53.882 23.3782 53.817 23.0562H47.744V23.0572ZM93.052 24.4582C92.698 23.5082 91.618 21.7512 89.411 21.7512C87.22 21.7512 85.399 23.4752 85.399 26.0042C85.399 28.3882 87.204 30.2572 89.62 30.2572C91.569 30.2572 92.697 29.0652 93.165 28.3722L91.715 27.4052C91.232 28.1142 90.571 28.5812 89.62 28.5812C88.67 28.5812 87.993 28.1462 87.558 27.2922L93.245 24.9402L93.052 24.4582ZM87.252 25.8762C87.204 24.2322 88.525 23.3952 89.476 23.3952C90.217 23.3952 90.845 23.7662 91.055 24.2972L87.252 25.8762ZM82.629 30.0002H84.497V17.4992H82.629V30.0002ZM79.567 22.7022H79.503C79.084 22.2022 78.278 21.7512 77.264 21.7512C75.137 21.7512 73.188 23.6202 73.188 26.0212C73.188 28.4052 75.137 30.2582 77.264 30.2582C78.279 30.2582 79.084 29.8072 79.503 29.2922H79.567V29.9042C79.567 31.5312 78.697 32.4012 77.296 32.4012C76.152 32.4012 75.443 31.5802 75.153 30.8872L73.526 31.5642C73.993 32.6912 75.233 34.0772 77.296 34.0772C79.487 34.0772 81.34 32.7882 81.34 29.6462V22.0102H79.568V22.7022H79.567ZM77.425 28.5832C76.136 28.5832 75.057 27.5032 75.057 26.0212C75.057 24.5222 76.136 23.4272 77.425 23.4272C78.697 23.4272 79.696 24.5222 79.696 26.0212C79.696 27.5032 78.697 28.5832 77.425 28.5832ZM101.806 17.4992H97.335V30.0002H99.2V25.2642H101.805C103.873 25.2642 105.907 23.7672 105.907 21.3822C105.907 18.9972 103.874 17.4992 101.806 17.4992ZM101.854 23.5242H99.2V19.2392H101.854C103.249 19.2392 104.041 20.3942 104.041 21.3822C104.041 22.3502 103.249 23.5242 101.854 23.5242ZM113.386 21.7292C112.035 21.7292 110.636 22.3242 110.057 23.6432L111.713 24.3342C112.067 23.6432 112.727 23.4172 113.418 23.4172C114.383 23.4172 115.364 23.9962 115.38 25.0252V25.1542C115.042 24.9612 114.318 24.6722 113.434 24.6722C111.649 24.6722 109.831 25.6532 109.831 27.4862C109.831 29.1592 111.295 30.2362 112.935 30.2362C114.189 30.2362 114.881 29.6732 115.315 29.0132H115.379V29.9782H117.181V25.1852C117.182 22.9672 115.524 21.7292 113.386 21.7292ZM113.16 28.5802C112.55 28.5802 111.697 28.2742 111.697 27.5182C111.697 26.5532 112.759 26.1832 113.676 26.1832C114.495 26.1832 114.882 26.3602 115.38 26.6012C115.235 27.7602 114.238 28.5802 113.16 28.5802ZM123.743 22.0022L121.604 27.4222H121.54L119.32 22.0022H117.31L120.639 29.5772L118.741 33.7912H120.687L125.818 22.0022H123.743ZM106.937 30.0002H108.802V17.4992H106.937V30.0002Z",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M47.418 10.243C47.418 11.081 47.1701 11.748 46.673 12.246C46.109 12.838 45.3731 13.134 44.4691 13.134C43.6031 13.134 42.8661 12.834 42.2611 12.234C41.6551 11.633 41.3521 10.889 41.3521 10.001C41.3521 9.11203 41.6551 8.36803 42.2611 7.76803C42.8661 7.16703 43.6031 6.86704 44.4691 6.86704C44.8991 6.86704 45.3101 6.95104 45.7001 7.11804C46.0911 7.28604 46.404 7.50904 46.6381 7.78804L46.111 8.31604C45.714 7.84104 45.167 7.60404 44.468 7.60404C43.836 7.60404 43.29 7.82604 42.829 8.27004C42.368 8.71404 42.1381 9.29104 42.1381 10C42.1381 10.709 42.368 11.286 42.829 11.73C43.29 12.174 43.836 12.396 44.468 12.396C45.138 12.396 45.6971 12.173 46.1441 11.726C46.4341 11.435 46.602 11.03 46.647 10.511H44.468V9.79004H47.375C47.405 9.94704 47.418 10.098 47.418 10.243Z",
    fill: "white"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M52.0281 7.73709H49.2961V9.63909H51.7601V10.3601H49.2961V12.2621H52.0281V13.0001H48.5251V7.00009H52.0281V7.73709Z",
    fill: "white"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M55.279 13.0001H54.508V7.73709H52.832V7.00009H56.955V7.73709H55.279V13.0001Z",
    fill: "white"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M59.938 13.0001V7.00009H60.709V13.0001H59.938Z",
    fill: "white"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M64.1281 13.0001H63.3572V7.73709H61.6812V7.00009H65.8042V7.73709H64.1281V13.0001Z",
    fill: "white"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M73.6089 12.2251C73.0189 12.8311 72.2859 13.1341 71.4089 13.1341C70.5319 13.1341 69.7989 12.8311 69.2099 12.2251C68.6199 11.6191 68.3259 10.8771 68.3259 10.0001C68.3259 9.12308 68.6199 8.38108 69.2099 7.77508C69.7989 7.16908 70.5319 6.86508 71.4089 6.86508C72.2809 6.86508 73.0129 7.17008 73.6049 7.77908C74.1969 8.38808 74.4929 9.12808 74.4929 10.0001C74.4929 10.8771 74.1979 11.6191 73.6089 12.2251ZM69.7789 11.7221C70.2229 12.1721 70.7659 12.3961 71.4089 12.3961C72.0519 12.3961 72.5959 12.1711 73.0389 11.7221C73.4829 11.2721 73.7059 10.6981 73.7059 10.0001C73.7059 9.30208 73.4829 8.72808 73.0389 8.27808C72.5959 7.82808 72.0519 7.60408 71.4089 7.60408C70.7659 7.60408 70.2229 7.82908 69.7789 8.27808C69.3359 8.72808 69.1129 9.30208 69.1129 10.0001C69.1129 10.6981 69.3359 11.2721 69.7789 11.7221Z",
    fill: "white"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M75.5749 13.0001V7.00009H76.513L79.429 11.6671H79.4619L79.429 10.5111V7.00009H80.1999V13.0001H79.3949L76.344 8.10609H76.3109L76.344 9.26209V13.0001H75.5749Z",
    fill: "white"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M47.418 10.243C47.418 11.081 47.1701 11.748 46.673 12.246C46.109 12.838 45.3731 13.134 44.4691 13.134C43.6031 13.134 42.8661 12.834 42.2611 12.234C41.6551 11.633 41.3521 10.889 41.3521 10.001C41.3521 9.11203 41.6551 8.36803 42.2611 7.76803C42.8661 7.16703 43.6031 6.86704 44.4691 6.86704C44.8991 6.86704 45.3101 6.95104 45.7001 7.11804C46.0911 7.28604 46.404 7.50904 46.6381 7.78804L46.111 8.31604C45.714 7.84104 45.167 7.60404 44.468 7.60404C43.836 7.60404 43.29 7.82604 42.829 8.27004C42.368 8.71404 42.1381 9.29104 42.1381 10C42.1381 10.709 42.368 11.286 42.829 11.73C43.29 12.174 43.836 12.396 44.468 12.396C45.138 12.396 45.6971 12.173 46.1441 11.726C46.4341 11.435 46.602 11.03 46.647 10.511H44.468V9.79004H47.375C47.405 9.94704 47.418 10.098 47.418 10.243Z",
    stroke: "white",
    strokeWidth: 0.2,
    strokeMiterlimit: 10
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M52.0281 7.73709H49.2961V9.63909H51.7601V10.3601H49.2961V12.2621H52.0281V13.0001H48.5251V7.00009H52.0281V7.73709Z",
    stroke: "white",
    strokeWidth: 0.2,
    strokeMiterlimit: 10
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M55.279 13.0001H54.508V7.73709H52.832V7.00009H56.955V7.73709H55.279V13.0001Z",
    stroke: "white",
    strokeWidth: 0.2,
    strokeMiterlimit: 10
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M59.938 13.0001V7.00009H60.709V13.0001H59.938Z",
    stroke: "white",
    strokeWidth: 0.2,
    strokeMiterlimit: 10
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M64.1281 13.0001H63.3572V7.73709H61.6812V7.00009H65.8042V7.73709H64.1281V13.0001Z",
    stroke: "white",
    strokeWidth: 0.2,
    strokeMiterlimit: 10
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M73.6089 12.2251C73.0189 12.8311 72.2859 13.1341 71.4089 13.1341C70.5319 13.1341 69.7989 12.8311 69.2099 12.2251C68.6199 11.6191 68.3259 10.8771 68.3259 10.0001C68.3259 9.12308 68.6199 8.38108 69.2099 7.77508C69.7989 7.16908 70.5319 6.86508 71.4089 6.86508C72.2809 6.86508 73.0129 7.17008 73.6049 7.77908C74.1969 8.38808 74.4929 9.12808 74.4929 10.0001C74.4929 10.8771 74.1979 11.6191 73.6089 12.2251ZM69.7789 11.7221C70.2229 12.1721 70.7659 12.3961 71.4089 12.3961C72.0519 12.3961 72.5959 12.1711 73.0389 11.7221C73.4829 11.2721 73.7059 10.6981 73.7059 10.0001C73.7059 9.30208 73.4829 8.72808 73.0389 8.27808C72.5959 7.82808 72.0519 7.60408 71.4089 7.60408C70.7659 7.60408 70.2229 7.82908 69.7789 8.27808C69.3359 8.72808 69.1129 9.30208 69.1129 10.0001C69.1129 10.6981 69.3359 11.2721 69.7789 11.7221Z",
    stroke: "white",
    strokeWidth: 0.2,
    strokeMiterlimit: 10
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "M75.5749 13.0001V7.00009H76.513L79.429 11.6671H79.4619L79.429 10.5111V7.00009H80.1999V13.0001H79.3949L76.344 8.10609H76.3109L76.344 9.26209V13.0001H75.5749Z",
    stroke: "white",
    strokeWidth: 0.2,
    strokeMiterlimit: 10
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_ii_9940_197790)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M10.4359 7.5381C10.1449 7.8461 9.9729 8.3241 9.9729 8.9431V31.0591C9.9729 31.6791 10.1449 32.1561 10.4359 32.4641L10.5099 32.5361L22.8989 20.1471V20.0011V19.8551L10.5099 7.4651L10.4359 7.5381Z",
    fill: "url(#paint0_linear_9940_197790)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M27.0279 24.2781L22.8989 20.1471V20.0011V19.8551L27.0289 15.7251L27.1219 15.7781L32.0149 18.5581C33.4119 19.3521 33.4119 20.6511 32.0149 21.4461L27.1219 24.2261L27.0279 24.2781Z",
    fill: "url(#paint1_linear_9940_197790)"
  }), /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter1_i_9940_197790)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M27.1218 24.2251L22.8978 20.0011L10.4358 32.4641C10.8958 32.9521 11.6568 33.0121 12.5138 32.5261L27.1218 24.2251Z",
    fill: "url(#paint2_linear_9940_197790)"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M27.1218 15.7771L12.5138 7.4771C11.6568 6.9901 10.8958 7.0511 10.4358 7.5391L22.8988 20.0021L27.1218 15.7771Z",
    fill: "url(#paint3_linear_9940_197790)"
  }))), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 0.5,
    y: 0.500092,
    width: 134,
    height: 39,
    rx: 4.5,
    stroke: "#A6A6A6"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_ii_9940_197790",
    x: 9.9729,
    y: 7.14102,
    width: 23.0898,
    height: 25.7207,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: -0.15
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "arithmetic",
    k2: -1,
    k3: 1
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.12 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "shape",
    result: "effect1_innerShadow_9940_197790"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 0.15
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "arithmetic",
    k2: -1,
    k3: 1
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 1 0 0 0 0 1 0 0 0 0 1 0 0 0 0.25 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "effect1_innerShadow_9940_197790",
    result: "effect2_innerShadow_9940_197790"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter1_i_9940_197790",
    x: 10.4358,
    y: 20.0011,
    width: 16.686,
    height: 12.8607,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: -0.15
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "arithmetic",
    k2: -1,
    k3: 1
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.08 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "shape",
    result: "effect1_innerShadow_9940_197790"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_9940_197790",
    x1: 21.8007,
    y1: 8.7091,
    x2: 5.0187,
    y2: 25.4911,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#00A0FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.0066,
    stopColor: "#00A1FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2601,
    stopColor: "#00BEFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5122,
    stopColor: "#00D2FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7604,
    stopColor: "#00DFFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#00E3FF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_9940_197790",
    x1: 33.8334,
    y1: 20.0011,
    x2: 9.63753,
    y2: 20.0011,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFE000"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4087,
    stopColor: "#FFBD00"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7754,
    stopColor: "#FFA500"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FF9C00"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_9940_197790",
    x1: 24.8279,
    y1: 22.295,
    x2: 2.06939,
    y2: 45.0535,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FF3A44"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#C31162"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint3_linear_9940_197790",
    x1: 7.29719,
    y1: 0.176898,
    x2: 17.4595,
    y2: 10.3392,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#32A071"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.0685,
    stopColor: "#2DA771"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4762,
    stopColor: "#15CF74"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8009,
    stopColor: "#06E775"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#00F076"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPlayStore);
export default __webpack_public_path__ + "static/media/play-store.d0ead5c00447771aa34a28c65cf388f9.svg";
export { ForwardRef as ReactComponent };